import type { SerializedEvent } from '@/lib/matrix/events'

interface ReplyComposerBarProps {
  event: SerializedEvent
  onDismiss: () => void
}

function getSenderDisplay(sender: string): string {
  const match = sender.match(/^@(.+?):/)
  return match?.[1] ?? sender
}

export function ReplyComposerBar({ event, onDismiss }: ReplyComposerBarProps) {
  const body = (event.content.body as string) ?? ''

  return (
    <div className="flex items-center gap-2 px-3 py-2 border-b border-[rgb(var(--np-border))] bg-[rgb(var(--np-raised)/0.5)]">
      <svg className="shrink-0 text-[rgb(var(--np-accent))]" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 17 4 12 9 7" />
        <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
      </svg>
      <div className="flex-1 min-w-0">
        <span className="text-xs font-semibold text-[rgb(var(--np-accent))]">
          {getSenderDisplay(event.sender)}
        </span>
        <p className="text-xs text-[rgb(var(--np-tx-muted))] truncate">{body}</p>
      </div>
      <button
        onClick={onDismiss}
        className="shrink-0 p-1 text-[rgb(var(--np-tx-muted))] hover:text-[rgb(var(--np-tx-primary))] transition-colors"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  )
}
